import DashInfo from "./Patient/DashInfo";
import ECard from "../UI/Ecard";
import { useEffect, useState, useContext } from "react";
import AuthContext from "../../store/auth-context";
import { getApiChara } from "../../util/getApi";
import { getAuthToken } from "../../util/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const Dashboard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [hospitalData, sethospitalData] = useState({});
  const [todayStats, setTodayStats] = useState({ total: 0, waiting: 0 });

  useEffect(() => {
    fetchHospitalDetails();
    fetchTodayStats();
  }, []);

  const fetchTodayStats = async () => {
    const token = getAuthToken();
    const apiChar = getApiChara();
    if (!token || token === "EXPIRED") return;

    try {
      const totalRes = await fetch(`${apiChar}/waitingList/getTodaysWaitingListCount`, {
        headers: { Authorization: 'Bearer ' + token },
      });
      const totalData = await totalRes.json();
      const total = typeof totalData === 'number' ? totalData : 0;

      const waitingRes = await fetch(`${apiChar}/waitingList/getTodaysWaitingListNotDoneCount`, {
        headers: { Authorization: 'Bearer ' + token },
      });
      const waitingData = await waitingRes.json();
      const waiting = typeof waitingData === 'number' ? waitingData : 0;

      setTodayStats({ total, waiting });
    } catch (err) {
      console.error("Error fetching banner stats:", err);
      setTodayStats({ total: 0, waiting: 0 });
    }
  };

  const fetchHospitalDetails = async () => {
    const token = getAuthToken();

    if (token === null || token === "EXPIRED") {
      navigate("/");
      return;
    }

    const apiChar = getApiChara();
    const apiUrl = `${apiChar}/HospitalConfiguration/getHospitalInfoWithAllConfigDetails`;

    try {
      const response = await fetch(apiUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        return;
      }

      const text = await response.text();
      if (!text) {
        toast.warning(t("Please add Hospital Data!"));
        return;
      }

      const data = JSON.parse(text);

      // Extract hospitalInfo
      const hospitalInfo = data?.hospitalInfo || {};

      // Extract configurations (make object for easy lookup)
      const configMap = {};
      (data?.configurations || []).forEach((c) => {
        configMap[c.paramCode] = c.paramValue;
      });

      sethospitalData(data);

      // Update Context
      authCtx.setHospitalData(hospitalInfo, configMap);

    } catch (error) {
      console.error("Error fetching hospital data:", error);
    }
  };


  return (
    <>
      <DashInfo
        title={hospitalData && (hospitalData?.hospitalInfo?.name || hospitalData?.name)}
        stats={todayStats}
      />
      <ECard hospitalData={hospitalData} />
    </>
  );
};

export default Dashboard;
